// Utility functions for managing incomplete bookings

export const saveIncompleteBooking = (bookingData) => {
  try {
    const bookingWithTimestamp = {
      ...bookingData,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem('incompleteBooking', JSON.stringify(bookingWithTimestamp));
  } catch (error) {
    console.error('Error saving incomplete booking:', error);
  }
};

export const getIncompleteBooking = () => {
  try {
    const savedBooking = localStorage.getItem('incompleteBooking');
    if (savedBooking) {
      const booking = JSON.parse(savedBooking);
      // Check if booking is less than 24 hours old
      const bookingTime = new Date(booking.timestamp);
      const now = new Date();
      const hoursDiff = (now - bookingTime) / (1000 * 60);
      
      if (hoursDiff < 2) { //2 minutes limit
        return booking;
      } else {
        // Remove expired booking
        localStorage.removeItem('incompleteBooking');
        if (window.location.pathname !== '/') {
          window.location.href = '/';
        }
        return null;
      }
    }
    return null;
  } catch (error) {
    console.error('Error getting incomplete booking:', error);
    localStorage.removeItem('incompleteBooking');
    return null;
  }
};

export const clearIncompleteBooking = () => {
  try {
    localStorage.removeItem('incompleteBooking');
     if (window.location.pathname !== '/') {
      window.location.href = '/';
    }
  } catch (error) {
    console.error('Error clearing incomplete booking:', error);
  }
};

export const updateIncompleteBooking = (updates) => {
  try {
    const existingBooking = getIncompleteBooking();
    if (existingBooking) {
      const updatedBooking = {
        ...existingBooking,
        ...updates,
        timestamp: new Date().toISOString() // Update timestamp
      };
      localStorage.setItem('incompleteBooking', JSON.stringify(updatedBooking));
      return updatedBooking;
    }
    return null;
  } catch (error) {
    console.error('Error updating incomplete booking:', error);
    return null;
  }
};
